import { NavLink } from "react-router-dom";
import { Home, Search, Package, DollarSign, User } from "lucide-react";

const ITEMS = [
  { to: "/dashboard", label: "Home", icon: Home, end: true },
  { to: "/find-loads", label: "Loads", icon: Search },
  { to: "/dashboard/my-loads", label: "My Loads", icon: Package },
  { to: "/dashboard/money", label: "Money", icon: DollarSign },
  { to: "/dashboard/profile", label: "Account", icon: User },
];

export function MobileBottomNav() {
  return (
    <nav data-testid="mobile-bottom-nav" className="lg:hidden fixed bottom-0 inset-x-0 z-50 bg-xd-paper border-t border-xd-border grid grid-cols-5">
      {ITEMS.map(({ to, label, icon: Icon, end }) => (
        <NavLink key={to} to={to} end={end} data-testid={`bottom-nav-${label.toLowerCase().replace(" ", "-")}`}
          className={({ isActive }) => `flex flex-col items-center justify-center gap-1 py-2.5 min-h-[56px] text-[11px] font-medium transition-colors ${isActive ? "text-xd-orange" : "text-xd-dim"}`}>
          <Icon size={20} />
          {label}
        </NavLink>
      ))}
    </nav>
  );
}
